import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
    Box,
    Typography,
    TextField,
    Button,
    Grid,
    Switch,
    ListItem,
    Checkbox,
    List,
    ListItemText,
    FormControlLabel,
    FormGroup,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Stack,
    Snackbar,
    IconButton,
    TablePagination,
    Card,
    CardContent,
    CircularProgress,
    Skeleton,
    Tooltip,
    Autocomplete,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
    Dashboard as DashboardIcon,
    Search as SearchIcon,
    Phone as PhoneIcon,
} from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import ReceiptIcon from "@mui/icons-material/Receipt";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {
    getCoupons,
    getAdminCompanyId,
    getUserCampaigns,
    updateUserToggle,
    getUserByMobile,
    getAdminCouponsByMobile,
    getValuebankByMobile,
    getCouponlogByMobile,
    getUserCampaignsByMobile,
    updateUserByMobile,
    createIndividualCoupons,
    createUserWithCoupons,
    updateCouponExpiry,
    adminAddedPoints,
    adminUsedPoints,
    updateValueBankComment,
    getCompanyValueBankStats,
    searchUsers,
} from "../../../api/api";
import ImageWithHover from "../../../components/ImageWithHover/ImageWithHover";
import AdminHeader from "../../../components/AdminHeader/AdminHeader";
import Cookies from "js-cookie";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import { formatAdminDate } from "../../../utils/formatDate";
import { getAdminNavLinks } from "../../../theme/adminNavLinks";
import { pageBackgroundSx } from "../../../theme/theme";
//import axios from "axios";

// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

// Styled components for better visual appeal
const StyledCard = styled(Card)(({ theme }) => ({
    borderRadius: 16,
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: '1px solid rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
        boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
        transform: 'translateY(-2px)',
    },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        borderRadius: 12,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 1)',
        },
        '&.Mui-focused': {
            backgroundColor: 'rgba(255, 255, 255, 1)',
        },
    },
}));



const AdminHome = () => {
    const location = useLocation();
    const admin_company_id = Cookies.get("admin_company_id");
    // console.log(admin_company_id, "admin_company_id");

    const [selectedDate, setSelectedDate] = useState(null);
    const [items, setItems] = useState([]);
    const [isCouponsLoading, setIsCouponsLoading] = useState(true);
    const [isAddingPoints, setIsAddingPoints] = useState(false);
    const [isUsingPoints, setIsUsingPoints] = useState(false);

    const [value, setValue] = React.useState("1");
    const [mainTabValue, setMainTabValue] = useState("1");

    const handleMainTabChange = (event, newValue) => {
        setMainTabValue(newValue);
    };
    const [campaigns, setCampaigns] = useState([]);
    const [balance, setBalance] = useState(25);
    const [used, setUsed] = useState(0);
    const [customPoints, setCustomPoints] = useState("");
    const [usePoints, setUsePoints] = useState("");
    const [comment, setComment] = useState("");
    const [admin, setAdmin] = useState("");
    const [internalComment, setInternalComment] = useState("");
    const [mobile, setMobile] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [isNewUserMode, setIsNewUserMode] = useState(false);
    const [userNotFound, setUserNotFound] = useState(false);
    const [userData, setUserData] = useState({
        id: "",
        mobile_number: "",
        name: "",
        email: "",
        valuebank_toggle: "",
        coupon_toggle: "",
        info_toggle: "",
        created_at: "",
        used_Points: "",
        earned_Points: "",
    });

    
    const [showSuccess, setShowSuccess] = useState(false);
    const [showCouponSuccess, setShowCouponSuccess] = useState(false);
    const [userId, setUserId] = useState(null);
    const [coupon, setCoupon] = useState([]);
    const [ValuebankPoints, setValuebankPoints] = useState([]);
    const [couponlog, setCouponlog] = useState([]);
    const [message, setMessage] = useState(`Hei,
        Vedlagt er linken til dine kuponger hos Fargerike Majorstuen
        https://kuponger.fabconcept.no
        Velkommen til hyggelig handel hos oss.
        Mvh
        Fargerike Majorstuen`);
    const [usedPoints, setUsedPoints] = useState(null);
    const [balancePoints, setBalancePoints] = useState(null);
    const [editingRow, setEditingRow] = useState(null); // track which row is editing
    
    // Pagination state for coupons table
    const [couponPage, setCouponPage] = useState(0);
    const [couponRowsPerPage, setCouponRowsPerPage] = useState(10);
    
    // Pagination state for Valuebank table
    const [valuebankPage, setValuebankPage] = useState(0);
    const [valuebankRowsPerPage, setValuebankRowsPerPage] = useState(10);
    
    // Pagination state for Couponlog table
    const [couponlogPage, setCouponlogPage] = useState(0);
    const [couponlogRowsPerPage, setCouponlogRowsPerPage] = useState(10);
    
    // Edit state for coupons table
    const [editingCouponId, setEditingCouponId] = useState(null);
    const [editingExpiryDate, setEditingExpiryDate] = useState(null);
    
    // Global value bank info toggle and company statistics
    const [globalValuebankToggle, setGlobalValuebankToggle] = useState(false);
    const [companyStats, setCompanyStats] = useState({
        yesterday: { earned: 0, used: 0, balance: 0 },
        last_7_days: { earned: 0, used: 0, balance: 0 },
        total: { earned: 0, used: 0, balance: 0 }
    });
    const [editValue, setEditValue] = useState(""); // track input value
    const [companyName, setCompanyName] = useState("");
    const [adminName, setAdminName] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);

    useEffect(() => {
        const fetchCompany = async () => {
          try {
            const admin_id = Cookies.get("admin_id");
            // const admin_company_id = Cookies.get("admin_company_id"); // if you still want it
      
            if (admin_id) {
              const response = await getAdminCompanyId(admin_id);
              //console.log(response.data, "company");
              setCompanyName(response.data.company.name);
             // console.log(response.data.company.name, "company name");
              setAdminName(response.data.admin.name);
             // console.log(response.data.admin.name, "admin name");
              // setAdminCompanyId(response.data.data);
            }
          } catch (error) {
            console.error("Error fetching company:", error);
          }
        };
      
        fetchCompany();
      }, []);
      
      // Read URL parameters and auto-populate mobile number
      useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const mobileParam = urlParams.get('mobile');
        
        if (mobileParam) {
          setMobile(mobileParam);
          // Automatically search for the user when mobile number is provided via URL
          handleMobileChange({ target: { value: mobileParam } });
        }
      }, [location.search]);
      
      

    const handleEdit = (row) => {
        setEditingRow(row.id); // use id instead of date
        setEditValue(row.admin_note || "");
    };

    const handleSaveEdit = (row) => {
        try {
            const response = updateValueBankComment(row.id, editValue);
            if (response.status === 200) {
              //  console.log("Comment updated successfully");
                const updatedRows = ValuebankPoints.map((r) =>
                    r.id === row.id ? { ...r, admin_note: editValue } : r
                );
                setValuebankPoints(updatedRows);

                setEditingRow(null);
                setEditValue("");
            } else {
                console.error("Failed to update comment");
            }
        } catch (error) {
            console.error("Error updating comment:", error);
        }
    };
    const fetchUserCampaigns = async (mobile) => {
        // Don't fetch if mobile is empty
        if (!mobile || mobile.trim() === '') {
            setCampaigns([]);
            return;
        }
        try {
            const response = await getUserCampaigns(mobile, admin_company_id);
            setCampaigns(response.data.data);
        } catch (error) {
            console.error("Failed to fetch campaigns:", error);
            setCampaigns([]);
        }
    };

    const handleToggle = async (mobileNumber, field, newValue) => {
        try {
            await updateUserToggle(mobileNumber, field, newValue);

            // ✅ Update the userData state to reflect the new toggle value
            setUserData((prevData) => ({
                ...prevData,
                [field]: newValue,
            }));
        } catch (error) {
            console.error("Error updating toggle:", error);
        }
    };

    const handleSendSms = async () => {
        if (!mobile.trim() || !message.trim()) {
            //alert("Please enter both mobile number and message.");
            Swal.fire({
                title: 'Error',
                text: 'Please enter both mobile number and message.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        // Add country code if missing
        let formattedNumber = mobile.trim();
        if (!formattedNumber.startsWith("47")) {
            formattedNumber = "47" + formattedNumber;
        }

        // const requestData = {
        //     key: "7kakk-anda4811-oiaei",
        //     avs: "Fargerike",
        //     dest: formattedNumber,
        //     msg: message,
        // };

        //console.log("Request Data:", requestData);
        // --------------------------------------- sms comment -------------------------------------------------->
        // try {
        //   const response = await axios.get(
        //     "https://smsgateway.digifront.biz/smsgateway.php",
        //     {
        //       params: requestData,
        //       headers: {
        //         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        //       }
        //     }
        //   );

        //   // Parse response if it's a string
        //   const jsonResponse =
        //     typeof response.data === "string"
        //       ? JSON.parse(response.data)
        //       : response.data;

        //   console.log("API Response:", jsonResponse);

        //   if (
        //     jsonResponse.STATUS === "OK" &&
        //     jsonResponse.error === 0 &&
        //     jsonResponse.messages &&
        //     jsonResponse.messages.length > 0
        //   ) {
        //     alert("✅ SMS sent successfully!");
        //   } else {
        //     alert(
        //       "❌ SMS failed: " +
        //         (jsonResponse.messages ? jsonResponse.messages[0].info : "Unknown error")
        //     );
        //   }
        // } catch (error) {
        //   console.error("SMS API Error:", error);
        //   alert("❌ Error sending SMS: " + error.message);
        // }
    };

    // Mobile number validation function
    const validateMobileNumber = (value) => {
        // Remove any non-digit characters
        const digitsOnly = value.replace(/\D/g, '');
        
        // Check if it's exactly 8 digits
        if (digitsOnly.length > 8) {
            return { isValid: false, error: "Mobile number must be maximum 8 digits" };
        }
        
        if (digitsOnly.length > 0 && digitsOnly.length < 8) {
            return { isValid: false, error: "Mobile number must be exactly 8 digits" };
        }
        
        if (digitsOnly.length === 8) {
            return { isValid: true, error: "" };
        }
        
        return { isValid: true, error: "" };
    };

    // Check if user exists and handle new user mode
    const checkUserExists = async (mobileNumber) => {
        try {
            const response = await getUserByMobile(mobileNumber, admin_company_id);
            return response.data && response.data.id; // User exists
        } catch (error) {
            return false; // User doesn't exist
        }
    };


    const handleMobileChange = async (e) => {
        const value = e.target.value;
        const validation = validateMobileNumber(value);
        
        setMobileError(validation.error);
        setMobile(value);

        // Only search if mobile number is valid (8 digits)
        if (validation.isValid && value.replace(/\D/g, '').length === 8) {
            try {
                const response = await getUserByMobile(value, admin_company_id);
                setUserData(response.data);
                setUserId(response.data.id);
                setIsNewUserMode(false); // User exists, exit new user mode
                setUserNotFound(false); // User found, clear not found message
               // console.log("User data from getByMobile:", response.data);
               // console.log("Points data:", response.data.points);
                handleUserCouponShow(value);
                handleUserValuebankPointsShow(value);
                handleUserCouponlogShow(value);
                handleUserCampaignDetails(value);
                fetchUserCampaigns(value);
            } catch (error) {
                // User doesn't exist, enter new user mode
                // Preserve existing name and email if user has entered them
                setUserData(prevData => ({
                    ...prevData,
                    id: "",
                    mobile_number: value,
                    created_at: "",
                    used_Points: "",
                    earned_Points: "",
                    valuebank_toggle: "",
                    coupon_toggle: 1,
                    info_toggle: 1
                }));
                setUserId(null);
                setIsNewUserMode(true);
                setUserNotFound(true); // Show user not found message
            }
        } else {
            // Clear all user-related data when mobile number is cleared or invalid
            setUserData({ 
                id: "",
                mobile_number: "",
                name: "",
                email: "",
                valuebank_toggle: "",
                coupon_toggle: "",
                info_toggle: "",
                created_at: "",
                used_Points: "",
                earned_Points: ""
            });
            setUserId(null);
            setIsNewUserMode(false);
            setUserNotFound(false); // Clear user not found message
            setCoupon([]);
            setValuebankPoints([]);
            setCouponlog([]);
            setCampaigns([]);
            setUsedPoints(null);
            setBalancePoints(null);
            // Reset pagination states
            setCouponlogPage(0);
            setCouponPage(0);
            setValuebankPage(0);
        }
    };

    const handleUserCouponShow = async (value) => {
        try {
            const response = await getAdminCouponsByMobile(value, admin_company_id);
            // Access the coupons array from the response
            const couponData = Array.isArray(response.data.coupons) ? response.data.coupons : [];
            setCoupon(couponData);
            //  console.log(response.data, "coupon data"); // Log the actual response
        } catch (error) {
            console.error("Error fetching coupons:", error);
            setCoupon([]); // Set to empty array on error
        }
    };

    const handleUserValuebankPointsShow = async (value) => {
        try {
            const response = await getValuebankByMobile(value, admin_company_id);
            // Ensure response.data.valueBankPoints is an array
            const valueBankData = Array.isArray(response.data.valueBankPoints) ? response.data.valueBankPoints : [];
            setValuebankPoints(valueBankData);
            setBalancePoints(response.data.availablePoints || 0);
            setUsedPoints(response.data.usedPoints || 0);

          //  console.log(response.data, "value bank data"); // Log the actual response
        } catch (error) {
            console.error("Error fetching value bank points:", error);
            setValuebankPoints([]); // Set to empty array on error
            setBalancePoints(0);
            setUsedPoints(0);
        }
    };

    const handleUserCouponlogShow = async (value) => {
        // Don't fetch if mobile is empty - clear data immediately
        if (!value || value.trim() === '') {
            setCouponlog([]);
            setCouponlogPage(0); // Reset pagination
            return;
        }
        try {
            const response = await getCouponlogByMobile(value, admin_company_id);
            // Coupon logs API returns direct array, not nested under 'coupons'
            const couponlogData = Array.isArray(response.data) ? response.data : [];
            setCouponlog(couponlogData);
            // console.log(response.data, "coupon data"); // Log the actual response
        } catch (error) {
            console.error("Error fetching coupons:", error);
            setCouponlog([]); // Set to empty array on error
        }
    };

    const handleUserCampaignDetails = async (value) => {
        // Don't fetch if mobile is empty - clear data immediately
        if (!value || value.trim() === '') {
            setCampaigns([]);
            return;
        }
        try {
            const response = await getUserCampaignsByMobile(value, admin_company_id);
            setCampaigns(response.data.data); // Correctly access 'data' key
            // console.log(response.data.data, "coupon data"); // Log actual campaign data
        } catch (error) {
            console.error("Error fetching campaigns:", error);
            setCampaigns([]); // Set to empty array on error
        }
    };

    const handleSave = async () => {
        try {
            await updateUserByMobile(mobile, {
                    name: userData.name,
                    email: userData.email,
                    admin_company_id: admin_company_id,
            });
            setShowSuccess(true);
        } catch (error) {
            //alert("Failed to update user");
            Swal.fire({
                title: 'Error',
                text: 'Failed to update user',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const handleCreateCoupons = async (mobile) => {
        // Validate mobile number is entered
        if (!mobile || mobile.trim() === '') {
            //alert("Please enter a mobile number before creating coupons.");
            Swal.fire({
                title: 'Error',
                text: 'Please enter a mobile number before creating coupons.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        // Filter items that have coupon selected (coupon checkbox is required)
        // Multiused is optional and only applies when coupon is checked
        const selectedItems = items.filter((item) => item.coupon);

        // Validate that all selected items have both coupon selection and expiry date
        const invalidItems = selectedItems.filter((item) => !item.expiryDate);
        
        if (invalidItems.length > 0) {
            //alert("Please select expiry date for all selected coupons before creating.");
            Swal.fire({
                title: 'Error',
                text: 'Please select expiry date for all selected coupons before creating.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        // Validate that expiry dates are not in the past
        const pastDateItems = selectedItems.filter((item) => {
            const today = new Date();
            const expiryDate = new Date(item.expiryDate);
            return expiryDate < today;
        });
        
        if (pastDateItems.length > 0) {
            //alert("Expiry date cannot be in the past. Please select a future date.");
            Swal.fire({
                title: 'Error',
                text: 'Expiry date cannot be in the past. Please select a future date.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        // Additional validation: check if any items are selected
        if (selectedItems.length === 0) {
           // alert("Please select at least one coupon to create.");
           Swal.fire({
            title: 'Error',
            text: 'Please select at least one coupon to create.',
            icon: 'error',
            confirmButtonText: 'OK'
           });
            return;
        }

        // Prepare coupons data for the combined API
        const couponsData = selectedItems.map((item) => ({
            coupon_initial_id: item.id,
            status: "active",
            end_date: item.expiryDate?.toISOString().split("T")[0] || null,
            multiused: item.multiused ? true : false,
        }));

        try {
            let response;
            
            if (!userId || isNewUserMode) {
                // Use combined API for new users
                response = await createUserWithCoupons({
                    mobile_number: mobile,
                    name: userData.name || `User ${mobile}`,
                    email: userData.email || "",
                    company_id: admin_company_id,
                    coupons: couponsData
                });
                
                if (response.data.status) {
                    const newUser = response.data.user;
                    setUserData(newUser);
                    setUserId(newUser.id);
                    setIsNewUserMode(false);
                    
                    if (response.data.is_new_user) {
                        //alert("✅ New user created and coupons assigned successfully!");
                        Swal.fire({
                            title: 'Success',
                            text: 'New user created and coupons assigned successfully!',
                            icon: 'success',
                            confirmButtonText: 'OK'
                        });
                        setUserNotFound(false);
                    } else {
                      // alert("✅ Coupons assigned to existing user successfully!");
                      Swal.fire({
                        title: 'Success',
                        text: 'Coupons assigned to existing user successfully!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                      });
                    }
                } else {
                    //alert("❌ Error: " + response.data.message);
                    Swal.fire({
                        title: 'Error',
                        text: '❌ Error: ' + response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                    return;
                }
            } else {
                // Use existing API for existing users
                const couponsPayload = selectedItems.map((item) => ({
                    company_id: admin_company_id,
                    coupon_initial_id: item.id,
                    user_id: userId,
                    status: "active",
                    end_date: item.expiryDate?.toISOString().split("T")[0] || null,
                    multiused: item.multiused ? true : false,
                }));
                
                response = await createIndividualCoupons({
                    coupons: couponsPayload,
                    admin_company_id: admin_company_id,
                });
                
                //alert("✅ Coupons assigned successfully!");
                Swal.fire({
                    title: 'Success',
                    text: 'Coupons assigned successfully!',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
            }
            
            setShowCouponSuccess(true);
            
            // Refresh user data and related information
            await handleUserCouponShow(mobile);
            handleUserValuebankPointsShow(mobile);
            handleUserCouponlogShow(mobile);
            handleUserCampaignDetails(mobile);
            fetchUserCampaigns(mobile);
            
            // Clear form fields
            setCustomPoints("");
            setComment("");
            setAdmin("");
            setInternalComment("");
            setSelectedDate(null);
            setUsePoints("");
            
            // Clear only coupon-related fields AFTER server refresh
            setTimeout(() => {
                setItems(prevItems => {
                    const updatedItems = prevItems.map((item) => ({
                        ...item,
                        expiryDate: null,
                        coupon: false,
                        multiused: false,
                    }));
                    
                    console.log("Clearing coupon fields - after server refresh:", updatedItems.map(item => ({ 
                        name: item.name, 
                        coupon: item.coupon, 
                        multiused: item.multiused, 
                        expiryDate: item.expiryDate 
                    })));
                    
                    return updatedItems;
                });
                
                // Force a re-render by updating a dummy state
                setShowCouponSuccess(false);
                setTimeout(() => setShowCouponSuccess(true), 10);
            }, 200); // Small delay to ensure server refresh is complete
        } catch (error) {
            console.error(
                "Error creating coupons:",
                error.response?.data || error
            );
        }
    };

    useEffect(() => {
        setIsCouponsLoading(true);
        getCoupons()
            .then((response) => {
                setItems(response.data.coupons);
                // console.log(response.data.coupon, "coupon data"); // Log the actual response
            })
            .catch((error) => {
                console.error("Error fetching coupons:", error);
            })
            .finally(() => {
                setIsCouponsLoading(false);
            });
        
    }, []);

    const handleAddPoints = (amount) => {
        setCustomPoints(amount);

        // Update the comment automatically
        setComment(`Administrator la til ${amount} poeng`);
    };

    const handleCustomAdd = async () => {
        const amount = parseInt(customPoints);

        if (
            !selectedDate ||
            !comment.trim() ||
            !admin.trim() ||
            !internalComment.trim()
        ) {
            //alert("Please fill in all fields");
            Swal.fire({
                title: 'Error',
                text: 'Please fill in all fields',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }
        if (!isNaN(amount)) {
            setIsAddingPoints(true);
            try {
                const response = await adminAddedPoints({
                    user_id: userId,
                    company_id: admin_company_id,
                    points: amount,
                    date: selectedDate.format("YYYY-MM-DD"),
                    description: comment,
                    admin_note: internalComment,
                    user: admin,
                });
                if (response.status === 200) {
                    setBalance(balance + amount);
                    setCustomPoints("");
                    setComment("");
                    setAdmin("");
                    setInternalComment("");
                    setSelectedDate(null);
                    // Refresh the valuebank points table
                    await handleUserValuebankPointsShow(userData.mobile_number);
                    //alert("Points added successfully");
                    Swal.fire({
                        title: 'Success',
                        text: 'Points added successfully',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });
                } else {
                    //alert("Failed to add points");
                    Swal.fire({
                        title: 'Error',
                        text: 'Failed to add points',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
            } catch (error) {
                console.error("Error adding points:", error);
                //alert("Failed to add points");
                Swal.fire({
                    title: 'Error',
                    text: 'Failed to add points',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            } finally {
                setIsAddingPoints(false);
            }
        }
    };

    const handleUsePoints = async () => {
        const amount = parseInt(usePoints);
        if (
            !selectedDate ||
            !comment.trim() ||
            !admin.trim() ||
            !internalComment.trim()
        ) {
           // alert("Please fill in all fields");
           Swal.fire({
            title: 'Error',
            text: 'Please fill in all fields',
            icon: 'error',
            confirmButtonText: 'OK'
           });
            return;
        }
        if (!isNaN(amount) && amount <= balance) {
            setIsUsingPoints(true);
            try {
                const response = await adminUsedPoints({
                    user_id: userId,
                    company_id: admin_company_id,
                    points: amount,
                });
                if (response.status === 200) {
                    setBalance(balance - amount);
                    setUsed(used + amount);
                    setUsePoints("");
                    // Refresh the valuebank points table to show updated data
                    await handleUserValuebankPointsShow(userData.mobile_number);
                    //alert("Points used successfully");
                    Swal.fire({
                        title: 'Success',
                        text: 'Points used successfully',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });
                } else {
                    //alert("Failed to use points");
                    Swal.fire({
                        title: 'Error',
                        text: 'Failed to use points',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
            } catch (error) {
                console.error("Error using points:", error);
                //alert("Failed to use points");
                Swal.fire({
                    title: 'Error',
                    text: 'Failed to use points',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            } finally {
                setIsUsingPoints(false);
            }
        } else {
            //alert("Insufficient balance");
            Swal.fire({
                title: 'Error',
                text: 'Insufficient balance',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // const generateCouponCode = () => {
    //     return (
    //         "CPN-" + Math.random().toString(36).substring(2, 10).toUpperCase()
    //     );
    // };

    const handleCheckboxChange = (index, field, value) => {
        const updatedItems = [...items];
        updatedItems[index][field] = value;
        
        // If coupon checkbox is unchecked, also uncheck multiused checkbox
        if (field === 'coupon' && !value) {
            updatedItems[index].multiused = false;
        }
        
        // If multiused checkbox is checked, also check coupon checkbox automatically
        if (field === 'multiused' && value) {
            updatedItems[index].coupon = true;
        }
        
        setItems(updatedItems);
    };

    // Pagination handlers for coupons table
    const handleCouponChangePage = (event, newPage) => {
        setCouponPage(newPage);
    };

    const handleCouponChangeRowsPerPage = (event) => {
        setCouponRowsPerPage(parseInt(event.target.value, 10));
        setCouponPage(0);
    };

    // Pagination handlers for Valuebank table
    const handleValuebankChangePage = (event, newPage) => {
        setValuebankPage(newPage);
    };

    const handleValuebankChangeRowsPerPage = (event) => {
        setValuebankRowsPerPage(parseInt(event.target.value, 10));
        setValuebankPage(0);
    };

    // Pagination handlers for Couponlog table
    const handleCouponlogChangePage = (event, newPage) => {
        setCouponlogPage(newPage);
    };

    const handleCouponlogChangeRowsPerPage = (event) => {
        setCouponlogRowsPerPage(parseInt(event.target.value, 10));
        setCouponlogPage(0);
    };

    // Edit handlers for coupons
    const handleEditCoupon = (couponId, currentExpiryDate) => {
        setEditingCouponId(couponId);
        setEditingExpiryDate(currentExpiryDate ? dayjs(currentExpiryDate) : null);
    };

    const handleCancelEdit = () => {
        setEditingCouponId(null);
        setEditingExpiryDate(null);
    };

    // Function to fetch company-wide value bank statistics
    const fetchCompanyStats = async () => {
        try {
            if (!admin_company_id) {
                console.error('Admin company ID not found');
                return;
            }
            
            const response = await getCompanyValueBankStats(admin_company_id);
            if (response.success) {
                setCompanyStats({
                    yesterday: response.data.yesterday || { earned: 0, used: 0, balance: 0 },
                    last_7_days: response.data.last_7_days || { earned: 0, used: 0, balance: 0 },
                    total: response.data.total || { earned: 0, used: 0, balance: 0 }
                });
            } else {
                console.error('Failed to fetch company stats:', response.message);
                // Fallback to default values
                setCompanyStats({
                    yesterday: { earned: 0, used: 0, balance: 0 },
                    last_7_days: { earned: 0, used: 0, balance: 0 },
                    total: { earned: 0, used: 0, balance: 0 }
                });
            }
        } catch (error) {
            console.error('Error fetching company stats:', error);
            // Fallback to default values on error
            setCompanyStats({
                yesterday: { earned: 0, used: 0, balance: 0 },
                last_7_days: { earned: 0, used: 0, balance: 0 },
                total: { earned: 0, used: 0, balance: 0 }
            });
        }
    };

    // Handle global value bank toggle
    const handleGlobalValuebankToggle = (enabled) => {
        setGlobalValuebankToggle(enabled);
        if (enabled) {
            fetchCompanyStats();
        }
    };

    const handleSaveCouponEdit = async (couponId) => {
        if (!editingExpiryDate) {
            Swal.fire({
                title: 'Error',
                text: 'Please select a valid expiry date',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        // Validate that the date is not in the past
        const today = dayjs();
        const selectedDate = dayjs(editingExpiryDate);

        if (selectedDate.isBefore(today, 'day')) {
            alert("Expiry date cannot be in the past. Please select a future date.");
            return;
        }

        try {
            console.log("Updating coupon expiry:", {
                coupon_id: couponId,
                end_date: editingExpiryDate.format('YYYY-MM-DD'),
                admin_company_id: admin_company_id,
            });

            // TODO: Backend endpoint needs to be created
            // The API endpoint 'api/admin/update-coupon-expiry' doesn't exist yet
            // Please create this endpoint in the backend
            
            // For now, show a message that this feature needs backend implementation
            //alert("This feature requires backend implementation. Please create the API endpoint: POST /api/admin/update-coupon-expiry");
            
            // Clear edit state anyway for testing
            handleCancelEdit();
            
            
            // Uncomment this when the backend endpoint is created:
            const response = await updateCouponExpiry(couponId, editingExpiryDate.format('YYYY-MM-DD'));

           // console.log("API Response:", response.data);
            //alert("Coupon expiry date updated successfully!");
            Swal.fire({
                title: 'Success',
                text: 'Coupon expiry date updated successfully!',
                icon: 'success',
                confirmButtonText: 'OK'
            });
            
            // Refresh the coupon data
            if (mobile) {
                await handleUserCouponShow(mobile);
            }
            
            // Clear edit state
            handleCancelEdit();
            
        } catch (error) {
            console.error("Error updating coupon expiry:", error);
            console.error("Error response:", error.response?.data);
          //  alert(`Failed to update coupon expiry date: ${error.response?.data?.message || error.message}`);
          Swal.fire({
            title: 'Error',
            text: `Failed to update coupon expiry date: ${error.response?.data?.message || error.message}`,
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
    };

    return (
            <Box sx={pageBackgroundSx}>
                {/* Admin Header with proper logout functionality */}
                <AdminHeader
                    title="Admin"
                    icon={DashboardIcon}
                    navigationLinks={getAdminNavLinks("/admin")}
                />

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {/* Search Section */}
                    <Box sx={{
                        p: 1,
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'stretch', sm: 'center' },
                        gap: { xs: 1.5, sm: 2 },
                        minWidth: 0,
                    }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
                            <SearchIcon color="primary" fontSize="small" />
                            User Search:
                        </Typography>
                        <Box sx={{
                            display: 'flex',
                            alignItems: { xs: 'stretch', sm: 'center' },
                            flexDirection: { xs: 'column', md: 'row' },
                            gap: 2,
                            flexGrow: 1,
                            minWidth: 0,
                        }}>
                            <Autocomplete
                                freeSolo
                                sx={{ width: '100%', maxWidth: { sm: 480 }, minWidth: 0 }}
                                options={searchResults}
                                inputValue={mobile} // Bind input value to mobile state
                                getOptionLabel={(option) => {
                                    if (typeof option === 'string') return option;
                                    return `${option.name} (${option.mobile_number})`;
                                }}
                                filterOptions={(x) => x} 
                                loading={searchLoading}
                                onInputChange={async (event, newInputValue) => {
                                    // Update mobile state immediately to reflect typing
                                    setMobile(newInputValue);
                                    
                                    // Clear all user data when field is cleared
                                    if (!newInputValue || newInputValue.trim() === '') {
                                        handleMobileChange({ target: { value: '' } });
                                        setSearchResults([]);
                                        return;
                                    }
                                    
                                    // Don't trigger search if it looks like a mobile number being typed
                                    // Only search names/emails or partial numbers
                                    if (newInputValue.length >= 2) {
                                        setSearchLoading(true);
                                        try {
                                            const response = await searchUsers(newInputValue, admin_company_id);
                                            setSearchResults(response.data.data || []);
                                        } catch (error) {
                                            console.error("Search failed:", error);
                                            setSearchResults([]);
                                        } finally {
                                            setSearchLoading(false);
                                        }
                                    } else {
                                        setSearchResults([]);
                                    }
                                    
                                    // Maintain existing direct mobile entry behavior
                                    if (newInputValue.replace(/\D/g, '').length === 8 && /^\d+$/.test(newInputValue)) {
                                        handleMobileChange({ target: { value: newInputValue } });
                                    }
                                }}
                                onChange={(event, newValue) => {
                                    if (newValue && typeof newValue !== 'string') {
                                        // When option selected, set mobile to the selected user's mobile
                                        setMobile(newValue.mobile_number);
                                        handleMobileChange({ target: { value: newValue.mobile_number } });
                                    }
                                }}
                                renderInput={(params) => (
                                    <StyledTextField
                                        {...params}
                                        label="Search Name or Mobile"
                                        variant="outlined"
                                        size="small"
                                        placeholder="Type name or mobile..."
                                        error={!!mobileError}
                                        helperText={mobileError}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: <SearchIcon fontSize="small" sx={{ color: 'text.secondary', mr: 1 }} />,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {searchLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.id}>
                                        <Typography variant="body2">
                                            {option.mobile_number} - {option.name} - {option.email || 'No email'}
                                        </Typography>
                                    </li>
                                )}
                            />
                            {userNotFound && (
                                <Typography
                                    sx={{
                                        color: 'error.main',
                                        fontSize: '0.875rem',
                                        fontWeight: 'bold',
                                        whiteSpace: { xs: 'normal', md: 'nowrap' },
                                    }}
                                >
                                    Mobile number not registered
                                </Typography>
                            )}
                        </Box>
                    </Box>

                    {/* Customer Info Line */}
                    <Box sx={{
                        p: 1,
                        px: 2,
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: { xs: 1, sm: 2, md: 4 },
                        rowGap: 1,
                        alignItems: 'center',
                        bgcolor: '#f5f5f5',
                        borderRadius: 1,
                        mx: 1,
                    }}>
                         <Typography variant="body2" sx={{ wordBreak: 'break-word' }}><strong>Customer Name:</strong> {userData.name || '---'}</Typography>
                         <Typography variant="body2"><strong>Mobile Number:</strong> {userData.mobile_number || '---'}</Typography>
                         <Typography variant="body2" sx={{ wordBreak: 'break-word', minWidth: 0 }}><strong>Email:</strong> {userData.email || '---'}</Typography>
                    </Box>

                    {/* Main Tabs */}
                    <TabContext value={mainTabValue}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList
                                onChange={handleMainTabChange}
                                aria-label="main tabs"
                                variant="scrollable"
                                scrollButtons="auto"
                                allowScrollButtonsMobile
                                sx={{
                                    '& .MuiTab-root': {
                                        minWidth: { xs: 0, sm: 72 },
                                        px: { xs: 1.5, sm: 2 },
                                        fontSize: { xs: '0.8rem', sm: '0.875rem' },
                                    },
                                }}
                            >
                                <Tab label="Profile" value="1" />
                                <Tab label="Account" value="2" />
                                <Tab label="Assign" value="3" />
                            </TabList>
                        </Box>

                        {/* Profile Tab */}
                        <TabPanel value="1">
                            <List sx={{
                                width: "100%",
                                maxWidth: { xs: "100%", md: 600 },
                                '& .MuiListItem-root': {
                                    flexDirection: { xs: 'column', sm: 'row' },
                                    alignItems: { xs: 'stretch', sm: 'center' },
                                },
                                '& .MuiListItemSecondaryAction-root': {
                                    position: { xs: 'relative', sm: 'absolute' },
                                    right: { xs: 'auto', sm: 16 },
                                    top: { xs: 'auto', sm: '50%' },
                                    transform: { xs: 'none', sm: 'translateY(-50%)' },
                                    width: { xs: '100%', sm: 'auto' },
                                    mt: { xs: 1, sm: 0 },
                                    alignSelf: { xs: 'stretch', sm: 'auto' },
                                },
                            }}>
                                <ListItem
                                    secondaryAction={
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            value={userData.mobile_number}
                                            disabled
                                            fullWidth
                                        />
                                    }
                                >
                                    <ListItemText primary="Mobile Number" />
                                </ListItem>
                                <ListItem
                                    secondaryAction={
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            value={userData.email}
                                            onChange={(e) => setUserData({ ...userData, email: e.target.value })}
                                            fullWidth
                                        />
                                    }
                                >
                                    <ListItemText primary="Email" />
                                </ListItem>
                                <ListItem
                                    secondaryAction={
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            value={userData.name}
                                            onChange={(e) => setUserData({ ...userData, name: e.target.value })}
                                            fullWidth
                                        />
                                    }
                                >
                                    <ListItemText primary="Customer Name" />
                                </ListItem>
                                <ListItem
                                    secondaryAction={
                                        <Box sx={{
                                            display: 'flex',
                                            gap: 2,
                                            alignItems: 'center',
                                            flexDirection: { xs: 'column', sm: 'row' },
                                            width: '100%',
                                        }}>
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                value={userData.created_at ? formatAdminDate(userData.created_at) : ''}
                                                disabled
                                                fullWidth
                                                sx={{ maxWidth: { sm: 220 } }}
                                            />
                                            <Tooltip title="Save User Details">
                                                <Button
                                                    variant="contained"
                                                    onClick={handleSave}
                                                    fullWidth
                                                    sx={{ maxWidth: { sm: 120 } }}
                                                    >
                                                        Save
                                                </Button>
                                            </Tooltip>
                                        </Box>
                                    }
                                >
                                    <ListItemText primary="Start/Stop Date" />
                                </ListItem>
                            </List>
                            <Snackbar
                                open={showSuccess}
                                autoHideDuration={3000}
                                onClose={() => setShowSuccess(false)}
                                message="User updated successfully"
                                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                            />
                        </TabPanel>

                        {/* Account Tab */}
                        <TabPanel value="2">
                             <Grid container spacing={2}>
                                {/* Toggles */}
                                <Grid item xs={12} md={6}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={<Switch checked={userData.valuebank_toggle === 1 || userData.valuebank_toggle === "1" || userData.valuebank_toggle === true} onChange={(e) => handleToggle(userData.mobile_number, "valuebank_toggle", e.target.checked ? 1 : 0)} />}
                                            label="Verdibank For User"
                                        />
                                        <FormControlLabel
                                            control={<Switch checked={userData.coupon_toggle === 1 || userData.coupon_toggle === "1" || userData.coupon_toggle === true} onChange={(e) => handleToggle(userData.mobile_number, "coupon_toggle", e.target.checked ? 1 : 0)} />}
                                            label="Coupon For User"
                                        />
                                        <FormControlLabel
                                            control={<Switch checked={userData.info_toggle === 1 || userData.info_toggle === "1" || userData.info_toggle === true} onChange={(e) => handleToggle(userData.mobile_number, "info_toggle", e.target.checked ? 1 : 0)} />}
                                            label="Wish to receive Information"
                                        />
                                    </FormGroup>
                                </Grid>
                                {/* Global Stats */}
                                <Grid item xs={12} md={6}>
                                     <FormGroup>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={globalValuebankToggle}
                                                        onChange={(e) => handleGlobalValuebankToggle(e.target.checked)}
                                                    />
                                                }
                                                label="Global Value Bank Info"
                                            />
                                        </FormGroup>
                                        {globalValuebankToggle && (
                                            <Box sx={{ mt: 2 }}>
                                                {/* Table for stats */}
                                                <TableContainer component={Paper} sx={{ maxWidth: '100%', maxHeight: { xs: 300, sm: 400 }, overflow: 'auto' }}>
                                                    <Table size="small" aria-label="company value bank stats">
                                                        <TableHead>
                                                            <TableRow sx={{ background: "#e9ecef" }}>
                                                                <TableCell><strong>Period</strong></TableCell>
                                                                <TableCell align="center"><strong>Earned</strong></TableCell>
                                                                <TableCell align="center"><strong>Used</strong></TableCell>
                                                                <TableCell align="center"><strong>Balance</strong></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell><strong>Yesterday</strong></TableCell>
                                                                <TableCell align="center">{companyStats.yesterday.earned}</TableCell>
                                                                <TableCell align="center">{companyStats.yesterday.used}</TableCell>
                                                                <TableCell align="center">{companyStats.yesterday.balance}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell><strong>Last 7 Days</strong></TableCell>
                                                                <TableCell align="center">{companyStats.last_7_days.earned}</TableCell>
                                                                <TableCell align="center">{companyStats.last_7_days.used}</TableCell>
                                                                <TableCell align="center">{companyStats.last_7_days.balance}</TableCell>
                                                            </TableRow>
                                                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                                                <TableCell><strong>Total</strong></TableCell>
                                                                <TableCell align="center"><strong>{companyStats.total.earned}</strong></TableCell>
                                                                <TableCell align="center"><strong>{companyStats.total.used}</strong></TableCell>
                                                                <TableCell align="center"><strong>{companyStats.total.balance}</strong></TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Box>
                                        )}
                                </Grid>
                             </Grid>

                             {/* Inner Tabs (Coupons, Verdibank, CouponLog) */}
                             <Box sx={{ mt: 4 }}>
                                <TabContext value={value}>
                                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                                        <TabList
                                            onChange={handleChange}
                                            aria-label="inner tabs"
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            allowScrollButtonsMobile
                                            sx={{
                                                '& .MuiTab-root': {
                                                    minWidth: { xs: 0, sm: 72 },
                                                    px: { xs: 1, sm: 2 },
                                                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                },
                                            }}
                                        >
                                            <Tab label="Coupons" value="1" />
                                            <Tab label="Verdibank" value="2" />
                                            <Tab label="CouponLog" value="3" />
                                            <Tab label="Valuebank Summary" value="4" />
                                            <Tab label="Send SMS" value="5"/>
                                            <Tab label="Campaign List" value="6"/>
                                        </TabList>
                                    </Box>
                                    <TabPanel value="1">
                                            <TableContainer component={Paper} sx={{ 
                                                maxHeight: { xs: 300, sm: 400 },
                                                overflow: 'auto',
                                                '&::-webkit-scrollbar': {
                                                    width: '8px',
                                                    height: '8px',
                                                },
                                                '&::-webkit-scrollbar-track': {
                                                    background: '#f1f1f1',
                                                    borderRadius: '4px',
                                                },
                                                '&::-webkit-scrollbar-thumb': {
                                                    background: '#c1c1c1',
                                                    borderRadius: '4px',
                                                    '&:hover': {
                                                        background: '#a8a8a8',
                                                    },
                                                },
                                            }}>
                                                <Table
                                                    sx={{ minWidth: 650 }}
                                                    size="small"
                                                    aria-label="a dense table"
                                                >
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>
                                                                MobileNr
                                                            </TableCell>
                                                            <TableCell>
                                                                Issued Coupon
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                Expired
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                Used
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                Active
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                Last Expiry Date
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                Actions
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(Array.isArray(coupon) ? coupon : [])
                                                            .sort((a, b) => {
                                                                // Sort by updated_at or created_at in descending order (newest first)
                                                                const dateA = new Date(a.updated_at || a.created_at || 0);
                                                                const dateB = new Date(b.updated_at || b.created_at || 0);
                                                                
                                                                // If both dates are valid, sort by date (descending), then by ID as tiebreaker
                                                                if (!isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
                                                                    const dateDiff = dateB.getTime() - dateA.getTime();
                                                                    // If dates are equal, sort by ID descending (newest first)
                                                                    return dateDiff !== 0 ? dateDiff : (b.id || 0) - (a.id || 0);
                                                                }
                                                                
                                                                // If only one has a valid date, prefer the one with a date
                                                                if (!isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return -1;
                                                                if (isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) return 1;
                                                                
                                                                // Fallback: sort by ID in descending order (newest first)
                                                                return (b.id || 0) - (a.id || 0);
                                                            })
                                                            .slice(couponPage * couponRowsPerPage, couponPage * couponRowsPerPage + couponRowsPerPage)
                                                            .map((row) => {
                                                            const expiredValue =
                                                                new Date(
                                                                    row.end_date
                                                                ).getTime() <
                                                                new Date().getTime()
                                                                    ? "Yes"
                                                                    : "No";
                                                            const editButtonLogic = (expiredValue === "No" && row.used !== 1);
                                                            const activeValue =
                                                                (expiredValue === "No" && row.used !== 1)
                                                                    ? "Yes"
                                                                    : "No";

                                                            const isExpired = expiredValue === "Yes";
                                                            const isUsed = row.used === 1;
                                                            const hasWarning = isExpired || isUsed;

                                                            return (
                                                                <TableRow
                                                                    key={row.id}
                                                                    sx={{
                                                                        backgroundColor: hasWarning ? '#fff3cd' : 'inherit', // Warning yellow background
                                                                        "&:last-child td, &:last-child th":
                                                                            {
                                                                                border: 0,
                                                                            },
                                                                        "&:hover": {
                                                                            backgroundColor: hasWarning ? '#ffeaa7' : '#f5f5f5', // Darker warning on hover
                                                                            },
                                                                    }}
                                                                >
                                                                    <TableCell
                                                                        component="th"
                                                                        scope="row"
                                                                    >
                                                                        {row.mobile_number ??
                                                                            mobile}{" "}
                                                                        {/* adjust if `mobile` is global */}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {
                                                                            row.coupon_initial_id
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {
                                                                            expiredValue
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {row.used ===
                                                                        0
                                                                            ? "No"
                                                                            : "Yes"}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {
                                                                            activeValue
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {editingCouponId === row.id ? (
                                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                <DatePicker
                                                                                    value={editingExpiryDate}
                                                                                    onChange={(newValue) => setEditingExpiryDate(newValue)}
                                                                                    minDate={dayjs().add(1, 'day')} // Prevent past dates
                                                                                    format="DD/MM/YYYY"
                                                                                    slotProps={{
                                                                                        textField: {
                                                                                            size: 'small',
                                                                                            sx: { width: 150 }
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </LocalizationProvider>
                                                                        ) : (
                                                                            row.end_date ? formatAdminDate(row.end_date) : 'N/A'
                                                                        )}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {editingCouponId === row.id ? (
                                                                            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                                                                                <Button
                                                                                    variant="contained"
                                                                                    color="primary"
                                                                                    size="small"
                                                                                    onClick={() => handleSaveCouponEdit(row.id)}
                                                                                >
                                                                                    Save
                                                                                </Button>
                                                                                <Button
                                                                                    variant="outlined"
                                                                                    size="small"
                                                                                    onClick={handleCancelEdit}
                                                                                >
                                                                                    Cancel
                                                                                </Button>
                                                                            </Box>
                                                                        ) : (
                                                                            <Button
                                                                                variant="outlined"
                                                                                size="small"
                                                                                disabled={!editButtonLogic}
                                                                                onClick={() => handleEditCoupon(row.id, row.end_date)}
                                                                            >
                                                                                Edit
                                                                            </Button>
                                                                        )}
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            
                                            {/* Pagination for coupons table */}
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                component="div"
                                                count={coupon.length}
                                                rowsPerPage={couponRowsPerPage}
                                                page={couponPage}
                                                onPageChange={handleCouponChangePage}
                                                onRowsPerPageChange={handleCouponChangeRowsPerPage}
                                                labelRowsPerPage="Rows per page:"
                                                labelDisplayedRows={({ from, to, count }) => 
                                                    `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
                                                }
                                            />
                                        </TabPanel>
                                        <TabPanel value="2">
                                            <TableContainer component={Paper} sx={{ 
                                                maxHeight: { xs: 300, sm: 400 },
                                                overflow: 'auto',
                                                overflowX: 'auto',
                                                maxWidth: '100%',
                                                '&::-webkit-scrollbar': {
                                                    width: '8px',
                                                    height: '8px',
                                                },
                                                '&::-webkit-scrollbar-track': {
                                                    background: '#f1f1f1',
                                                    borderRadius: '4px',
                                                },
                                                '&::-webkit-scrollbar-thumb': {
                                                    background: '#c1c1c1',
                                                    borderRadius: '4px',
                                                    '&:hover': {
                                                        background: '#a8a8a8',
                                                    },
                                                },
                                            }}>
                                                <Paper
                                                    elevation={2}
                                                    sx={{ p: 2 }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: { xs: 'column', sm: 'row' },
                                                            flexWrap: 'wrap',
                                                            gap: 2,
                                                            alignItems: { xs: 'flex-start', sm: 'center' },
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="h5"
                                                            fontWeight="bold"
                                                            mb={{ xs: 0, sm: 2 }}
                                                        >
                                                            Verdibank
                                                        </Typography>
                                                        <Typography
                                                            sx={{ mt: { xs: 0, sm: 0.5 }, wordBreak: 'break-word' }}
                                                        >
                                                            <strong>
                                                                Name:
                                                            </strong>{" "}
                                                            {userData.name}
                                                            &nbsp;&nbsp;
                                                            <strong>
                                                                Id:
                                                            </strong>{" "}
                                                            {
                                                                userData.mobile_number
                                                            }
                                                        </Typography>
                                                    </Box>

                                                    <Grid
                                                        container
                                                        spacing={1}
                                                        alignItems="center"
                                                    >
                                                        {/* Add Points Buttons */}
                                                        <Grid size={{ xs: 12, sm: 6, lg: 3 }} item>
                                                            <Typography>
                                                                Add Points
                                                            </Typography>
                                                            <Stack
                                                                direction="row"
                                                                spacing={1}
                                                                mt={1}
                                                            >
                                                                <Button
                                                                    variant="contained"
                                                                    onClick={() =>
                                                                        handleAddPoints(
                                                                            25
                                                                        )
                                                                    }
                                                                >
                                                                    +25
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    onClick={() =>
                                                                        handleAddPoints(
                                                                            50
                                                                        )
                                                                    }
                                                                >
                                                                    {" "}
                                                                    +50
                                                                </Button>
                                                            </Stack>
                                                        </Grid>

                                                        {/* Used & Balance */}
                                                        <Grid size={{ xs: 12, sm: 6, lg: 2 }} item>
                                                            <Typography>
                                                                <strong>
                                                                    Used:
                                                                    {Math.abs(
                                                                        usedPoints
                                                                    )}
                                                                </strong>{" "}
                                                            </Typography>
                                                            <Typography>
                                                                <strong>
                                                                    Balance:
                                                                    {
                                                                        balancePoints
                                                                    }
                                                                </strong>{" "}
                                                            </Typography>
                                                        </Grid>

                                                        {/* Comment fields */}
                                                        <Grid item size={{ xs: 12, md: 6, lg: 4 }}>
                                                            <TextField
                                                                label="Comment"
                                                                fullWidth
                                                                size="small"
                                                                value={comment}
                                                                onChange={(e) =>
                                                                    setComment(
                                                                        e.target
                                                                            .value
                                                                    )
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid item size={{ xs: 12, sm: 6, lg: 3 }}>
                                                            <TextField
                                                                label="Admin"
                                                                fullWidth
                                                                size="small"
                                                                value={admin}
                                                                onChange={(e) =>
                                                                    setAdmin(
                                                                        e.target
                                                                            .value
                                                                    )
                                                                }
                                                            />
                                                        </Grid>

                                                        {/* Add Points Custom */}
                                                        <Grid item size={{ xs: 12, sm: 6, lg: 3 }}>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: 'center',
                                                                    gap: 1,
                                                                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                                                                }}
                                                            >
                                                                <TextField
                                                                    placeholder="Amount"
                                                                    value={customPoints}
                                                                    size="small"
                                                                    fullWidth
                                                                    sx={{ minWidth: { xs: 0, sm: 100 }, flex: { xs: '1 1 100%', sm: '1 1 auto' } }}
                                                                    onChange={(e) =>
                                                                        setCustomPoints(e.target.value)
                                                                    }
                                                                />
                                                                <Button
                                                                    variant="contained"
                                                                    disabled={isAddingPoints}
                                                                    onClick={handleCustomAdd}
                                                                    sx={{
                                                                        minWidth: 100,
                                                                        flexShrink: 0,
                                                                        alignSelf: { xs: 'stretch', sm: 'center' },
                                                                    }}
                                                                >
                                                                    {isAddingPoints ? (
                                                                        <>
                                                                            <CircularProgress size={16} sx={{ mr: 1 }} />
                                                                            Adding...
                                                                        </>
                                                                    ) : (
                                                                        "Add"
                                                                    )}
                                                                </Button>
                                                            </Box>
                                                        </Grid>

                                                        {/* Use Points */}
                                                        <Grid item size={{ xs: 12, sm: 6, lg: 3 }}>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: 'center',
                                                                    gap: 1,
                                                                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                                                                }}
                                                            >
                                                                <TextField
                                                                    placeholder="Amount"
                                                                    size="small"
                                                                    value={usePoints}
                                                                    fullWidth
                                                                    sx={{ minWidth: { xs: 0, sm: 100 }, flex: { xs: '1 1 100%', sm: '1 1 auto' } }}
                                                                    onChange={(e) =>
                                                                        setUsePoints(e.target.value)
                                                                    }
                                                                />
                                                                <Button
                                                                    variant="contained"
                                                                    color="warning"
                                                                    disabled={isUsingPoints}
                                                                    onClick={handleUsePoints}
                                                                    sx={{
                                                                        minWidth: 100,
                                                                        flexShrink: 0,
                                                                        alignSelf: { xs: 'stretch', sm: 'center' },
                                                                    }}
                                                                >
                                                                    {isUsingPoints ? (
                                                                        <>
                                                                            <CircularProgress size={16} sx={{ mr: 1 }} />
                                                                            Using...
                                                                        </>
                                                                    ) : (
                                                                        "Use"
                                                                    )}
                                                                </Button>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item size={{ xs: 12, md: 7, lg: 3.5 }}>
                                                            <TextField
                                                                label="Internal Comment"
                                                                fullWidth
                                                                size="small"
                                                                value={
                                                                    internalComment
                                                                }
                                                                onChange={(e) =>
                                                                    setInternalComment(
                                                                        e.target
                                                                            .value
                                                                    )
                                                                }
                                                            />
                                                        </Grid>
                                                        {/* Date Picker */}
                                                        <Grid item size={{ xs: 12, md: 5, lg: 2.5 }}>
                                                            <LocalizationProvider
                                                                dateAdapter={
                                                                    AdapterDayjs
                                                                }
                                                                adapterLocale="nb"
                                                            >
                                                                <DatePicker
                                                                    label="Select Date"
                                                                    format="DD/MM/YYYY"
                                                                    value={
                                                                        selectedDate
                                                                    }
                                                                    onChange={(
                                                                        newValue
                                                                    ) =>
                                                                        setSelectedDate(
                                                                            newValue
                                                                        )
                                                                    }
                                                                    minDate={dayjs().subtract(
                                                                        7,
                                                                        "day"
                                                                    )} // 1 week back
                                                                    maxDate={dayjs().add(
                                                                        4,
                                                                        "day"
                                                                    )} // 4 days into the future
                                                                    slotProps={{
                                                                        textField:
                                                                            {
                                                                                fullWidth: true,
                                                                                size: "small",
                                                                            },
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </Grid>
                                                    </Grid>
                                                </Paper>
                                                <Table
                                                    sx={{
                                                        minWidth: 650,
                                                        mt: 2,
                                                    }}
                                                    size="small"
                                                    aria-label="a dense table"
                                                >
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>
                                                                Date
                                                            </TableCell>
                                                            <TableCell>
                                                                Point
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                User
                                                            </TableCell>
                                                            <TableCell align="center">
                                                               Internal Comment
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                 Comment
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                Action
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(Array.isArray(ValuebankPoints) ? ValuebankPoints : [])
                                                            .sort((a, b) => new Date(b.date) - new Date(a.date))
                                                            .slice(valuebankPage * valuebankRowsPerPage, valuebankPage * valuebankRowsPerPage + valuebankRowsPerPage)
                                                            .map((row) => (
                                                                <TableRow
                                                                    key={row.id} // ✅ use id for key
                                                                    sx={{
                                                                        backgroundColor:
                                                                            row.points >
                                                                            0
                                                                                ? "#e0f7fa"
                                                                                : "#ffebee",
                                                                        "&:last-child td, &:last-child th":
                                                                            {
                                                                                border: 0,
                                                                            },
                                                                    }}
                                                                >
                                                                    <TableCell>
                                                                        {
                                                                            row.date ? 
                                                                                formatAdminDate(row.date) : 
                                                                                'N/A'
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {
                                                                            row.points
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        {
                                                                            row.user
                                                                        }
                                                                    </TableCell>

                                                                    {/* Internal Comment */}
                                                                    <TableCell align="center">
                                                                        {editingRow ===
                                                                        row.id ? (
                                                                            <TextField
                                                                                size="small"
                                                                                value={
                                                                                    editValue
                                                                                }
                                                                                onChange={(
                                                                                    e
                                                                                ) =>
                                                                                    setEditValue(
                                                                                        e
                                                                                            .target
                                                                                            .value
                                                                                    )
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            row.admin_note ||
                                                                            " -"
                                                                        )}
                                                                    </TableCell>

                                                                    <TableCell align="center">
                                                                        {row.description ||
                                                                            " -"}
                                                                    </TableCell>

                                                                    {/* Action */}
                                                                    <TableCell align="center">
                                                                        {editingRow ===
                                                                        row.id ? (
                                                                            <>
                                                                                {/* Save */}
                                                                                <IconButton
                                                                                    color="success"
                                                                                    onClick={() =>
                                                                                        handleSaveEdit(
                                                                                            row
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <CheckIcon />
                                                                                </IconButton>
                                                                                {/* Cancel */}
                                                                                <IconButton
                                                                                    color="error"
                                                                                    onClick={() =>
                                                                                        setEditingRow(
                                                                                            null
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <CloseIcon />
                                                                                </IconButton>
                                                                            </>
                                                                        ) : (
                                                                            <IconButton
                                                                                color="primary"
                                                                                onClick={() =>
                                                                                    handleEdit(
                                                                                        row
                                                                                    )
                                                                                }
                                                                            >
                                                                                <EditIcon />
                                                                            </IconButton>
                                                                        )}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            
                                            {/* Pagination for Valuebank table */}
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                component="div"
                                                count={ValuebankPoints.length}
                                                rowsPerPage={valuebankRowsPerPage}
                                                page={valuebankPage}
                                                onPageChange={handleValuebankChangePage}
                                                onRowsPerPageChange={handleValuebankChangeRowsPerPage}
                                                labelRowsPerPage="Rows per page:"
                                                labelDisplayedRows={({ from, to, count }) => 
                                                    `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
                                                }
                                            />
                                        </TabPanel>
                                        <TabPanel value="3">
                                            <TableContainer component={Paper} sx={{ 
                                                maxHeight: { xs: 300, sm: 400 },
                                                overflow: 'auto',
                                                '&::-webkit-scrollbar': {
                                                    width: '8px',
                                                    height: '8px',
                                                },
                                                '&::-webkit-scrollbar-track': {
                                                    background: '#f1f1f1',
                                                    borderRadius: '4px',
                                                },
                                                '&::-webkit-scrollbar-thumb': {
                                                    background: '#c1c1c1',
                                                    borderRadius: '4px',
                                                    '&:hover': {
                                                        background: '#a8a8a8',
                                                    },
                                                },
                                            }}>
                                                <Table
                                                    sx={{ minWidth: 650 }}
                                                    size="small"
                                                    aria-label="a dense table"
                                                >
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>
                                                                Date
                                                            </TableCell>
                                                            <TableCell>
                                                                Action
                                                            </TableCell>
                                                            <TableCell>
                                                                Remark
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {couponlog
                                                            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                                                            .slice(
                                                                couponlogPage * couponlogRowsPerPage,
                                                                couponlogPage * couponlogRowsPerPage + couponlogRowsPerPage
                                                            )
                                                            .map(
                                                            (row) => (
                                                                <TableRow
                                                                    key={
                                                                        row.name
                                                                    }
                                                                >
                                                                    <TableCell>
                                                                        {formatAdminDate(
                                                                            row.created_at
                                                                        ) ||
                                                                            " - "}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {
                                                                            row.action
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {
                                                                            row.remark
                                                                        }
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            
                                            {/* Pagination for Couponlog table */}
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                component="div"
                                                count={couponlog.length}
                                                rowsPerPage={couponlogRowsPerPage}
                                                page={couponlogPage}
                                                onPageChange={handleCouponlogChangePage}
                                                onRowsPerPageChange={handleCouponlogChangeRowsPerPage}
                                                labelRowsPerPage="Rows per page:"
                                                labelDisplayedRows={({ from, to, count }) => 
                                                    `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
                                                }
                                            />
                                        </TabPanel>
                                        <TabPanel value="4">
                                            <TableContainer component={Paper} sx={{ 
                                                maxHeight: { xs: 300, sm: 400 },
                                                overflow: 'auto',
                                                '&::-webkit-scrollbar': {
                                                    width: '8px',
                                                    height: '8px',
                                                },
                                                '&::-webkit-scrollbar-track': {
                                                    background: '#f1f1f1',
                                                    borderRadius: '4px',
                                                },
                                                '&::-webkit-scrollbar-thumb': {
                                                    background: '#c1c1c1',
                                                    borderRadius: '4px',
                                                    '&:hover': {
                                                        background: '#a8a8a8',
                                                    },
                                                },
                                            }}>
                                                <Table
                                                    sx={{ minWidth: 650 }}
                                                    size="small"
                                                    aria-label="a dense table"
                                                >
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>
                                                                #
                                                            </TableCell>
                                                            <TableCell>
                                                                Yesterday
                                                            </TableCell>
                                                            <TableCell>
                                                                Last 7 Days
                                                            </TableCell>
                                                            <TableCell>
                                                                Total
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>
                                                                Earned
                                                            </TableCell>
                                                            <TableCell>
                                                                {userData.points?.yesterday?.earned || 0}
                                                            </TableCell>
                                                            <TableCell>
                                                                {userData.points?.last_7_days?.earned || 0}
                                                            </TableCell>
                                                            <TableCell>
                                                                {userData.points?.total?.earned || 0}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell>
                                                                Used
                                                            </TableCell>
                                                            <TableCell>
                                                                {userData.points?.yesterday?.used || 0}
                                                            </TableCell>
                                                            <TableCell>
                                                                {userData.points?.last_7_days?.used || 0}
                                                            </TableCell>
                                                            <TableCell>
                                                                {userData.points?.total?.used || 0}
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell>
                                                                Balance
                                                            </TableCell>
                                                            <TableCell>
                                                                {userData.points?.yesterday?.balance || 0}
                                                            </TableCell>
                                                            <TableCell>
                                                                {userData.points?.last_7_days?.balance || 0}
                                                            </TableCell>
                                                            <TableCell>
                                                                {userData.points?.total?.balance || 0}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </TabPanel>
                                        <TabPanel value="5">
                                            <Typography variant="h5">
                                                Send SMS to Customer
                                            </Typography>
                                            <Box
                                                sx={{
                                                    // width: 500,
                                                    maxWidth: "100%",
                                                    mt: 1,
                                                }}
                                            >
                                                <TextField
                                                    fullWidth
                                                    rows={6}
                                                    multiline
                                                    // label="Multiline"
                                                    id="fullWidth"
                                                    defaultValue=" Hei,
                                                        Vedlagt er linken til dine kuponger hos Fargerike Majorstuen
                                                        https://kuponger.fabconcept.no
                                                        Velkommen til hyggelig handel hos oss.
                                                        Mvh
                                                        Fargerike Majorstuen"
                                                />
                                                <Button
                                                    variant="contained"
                                                    sx={{ mt: 2 }}
                                                    onClick={handleSendSms}
                                                >
                                                    Send SMS
                                                </Button>
                                            </Box>
                                        </TabPanel>
                                        <TabPanel value="6">
                                            <TableContainer component={Paper} sx={{ 
                                                maxHeight: { xs: 300, sm: 400 },
                                                overflow: 'auto',
                                                '&::-webkit-scrollbar': {
                                                    width: '8px',
                                                    height: '8px',
                                                },
                                                '&::-webkit-scrollbar-track': {
                                                    background: '#f1f1f1',
                                                    borderRadius: '4px',
                                                },
                                                '&::-webkit-scrollbar-thumb': {
                                                    background: '#c1c1c1',
                                                    borderRadius: '4px',
                                                    '&:hover': {
                                                        background: '#a8a8a8',
                                                    },
                                                },
                                            }}>
                                                <Table
                                                    sx={{ minWidth: 650 }}
                                                    size="small"
                                                    aria-label="a dense table"
                                                >
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>
                                                               Date Added
                                                            </TableCell>
                                                            <TableCell>
                                                              Campaign Name
                                                            </TableCell>
                                                            <TableCell>
                                                              Partner Name
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                        (Array.isArray(campaigns) ? campaigns : [])
                                                            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                                                            .map((row) => (
                                                            <TableRow key={row.name}>
                                                                <TableCell>
                                                                    {row.created_at ? 
                                                                        formatAdminDate(row.created_at) : 
                                                                        'N/A'
                                                                    }
                                                                </TableCell>
                                                                <TableCell>{row.name}</TableCell>
                                                                <TableCell>{row.partner ?? "N/A"}</TableCell>
                                                            </TableRow>
                                                        )) || "No campaigns found"
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </TabPanel>
                                </TabContext>
                             </Box>
                        </TabPanel>

                        {/* Assign Tab */}
                        <TabPanel value="3" sx={{ px: { xs: 0.5, sm: 2 }, maxWidth: '100%', overflow: 'hidden' }}>
                            <Box sx={{ p: { xs: 1, sm: 2 }, border: "1px solid #ccc", borderRadius: 2, maxWidth: '100%', minWidth: 0 }}>
                                {/* Header Row — desktop / tablet only; mobile uses per-field labels */}
                                <Grid container spacing={2} alignItems="center" sx={{ mb: 1, display: { xs: 'none', sm: 'flex' } }}>
                                    <Grid item size={1} sx={{ textAlign: "center", p: 0 }}>
                                        <Typography sx={{ fontWeight: 600, color: '#d32f2f', fontSize: '0.8rem' }}>
                                            Coupon *
                                        </Typography>
                                    </Grid>
                                    <Grid item size={1} sx={{ textAlign: "center", p: 0 }}>
                                        <Typography sx={{ fontWeight: 500, color: '#666', fontSize: '0.8rem' }}>
                                            Multiused
                                        </Typography>
                                    </Grid>
                                    <Grid item size={2} sx={{ textAlign: "center", px: 0.5 }}>
                                        <Typography sx={{ fontWeight: 600, color: '#d32f2f', fontSize: '0.9rem' }}>
                                            Expiry Date *
                                        </Typography>
                                    </Grid>
                                    <Grid item size={8}>
                                        <Typography sx={{ fontWeight: 600 }}> Name</Typography>
                                    </Grid>
                                </Grid>

                                {/* Loading State */}
                                {isCouponsLoading ? (
                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 4, gap: 2 }}>
                                        <CircularProgress size={40} />
                                        <Typography variant="body2" sx={{ color: "#666" }}>
                                            Loading coupons...
                                        </Typography>
                                    </Box>
                                ) : (
                                    /* Mapped Rows */
                                    items.map((item, index) => (
                                        <Grid
                                            container
                                            spacing={2}
                                            alignItems="center"
                                            key={item.id}
                                            sx={{
                                                mb: { xs: 2, sm: 1 },
                                                pb: { xs: 2, sm: 0 },
                                                borderBottom: { xs: '1px solid #eee', sm: 'none' },
                                                '&:last-of-type': { borderBottom: { xs: 'none' } },
                                            }}
                                        >
                                            <Grid item size={{ xs: 6, sm: 1 }} sx={{ textAlign: "center", p: 0 }}>
                                                <Typography variant="caption" sx={{ display: { xs: 'block', sm: 'none' }, fontWeight: 600, color: 'error.main' }}>
                                                    Coupon *
                                                </Typography>
                                                <Checkbox
                                                    key={`coupon-${index}-${item.coupon}`}
                                                    size="small"
                                                    checked={item.coupon}
                                                    onChange={(e) => handleCheckboxChange(index, "coupon", e.target.checked)}
                                                    sx={{ p: 0.5 }}
                                                />
                                            </Grid>
                                            <Grid item size={{ xs: 6, sm: 1 }} sx={{ textAlign: "center", p: 0 }}>
                                                <Typography variant="caption" sx={{ display: { xs: 'block', sm: 'none' }, color: 'text.secondary' }}>
                                                    Multiused
                                                </Typography>
                                                <Checkbox
                                                    key={`multiused-${index}-${item.multiused}`}
                                                    size="small"
                                                    checked={item.multiused}
                                                    onChange={(e) => handleCheckboxChange(index, "multiused", e.target.checked)}
                                                    sx={{ p: 0.5 }}
                                                />
                                            </Grid>
                                            <Grid item size={{ xs: 12, sm: 2 }} sx={{
                                                minWidth: 0,
                                                display: 'flex',
                                                flexDirection: { xs: 'column', sm: 'row' },
                                                justifyContent: { xs: 'stretch', sm: 'flex-start' },
                                                alignItems: { xs: 'stretch', sm: 'center' },
                                            }}>
                                                <Typography variant="caption" sx={{ display: { xs: 'block', sm: 'none' }, fontWeight: 600, color: 'error.main', mb: 0.5 }}>
                                                    Expiry Date *
                                                </Typography>
                                                <DatePicker
                                                    value={item.expiryDate}
                                                    minDate={dayjs()}
                                                    format="DD/MM/YYYY"
                                                    onChange={(newDate) => {
                                                        const updatedItems = [...items];
                                                        updatedItems[index].expiryDate = newDate;
                                                        if (index === 0 && newDate) {
                                                            updatedItems.forEach((itm, idx) => {
                                                                if (idx !== 0) itm.expiryDate = newDate;
                                                            });
                                                        }
                                                        setItems(updatedItems);
                                                    }}
                                                    slotProps={{
                                                        textField: {
                                                            size: "small",
                                                            fullWidth: true,
                                                            sx: {
                                                                maxWidth: { xs: '100%', sm: 148 },
                                                                width: { sm: 148 },
                                                                "& .MuiInputBase-root": { fontSize: "13px", minHeight: "32px", padding: "0 6px" },
                                                                "& .MuiInputBase-input": { padding: "4px 0" },
                                                                "& .MuiInputLabel-root": { fontSize: "11px" },
                                                            },
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item size={{ xs: 12, sm: 8 }} sx={{ minWidth: 0 }}>
                                                <Typography variant="caption" sx={{ display: { xs: 'block', sm: 'none' }, fontWeight: 600, mb: 0.5 }}>
                                                    Name
                                                </Typography>
                                                <Box display="flex" alignItems="center" sx={{ minWidth: 0 }}>
                                                    <ImageWithHover icon={<ReceiptIcon />} imageUrl={item.coupon_image_url} />
                                                    <Typography variant="body2" sx={{ ml: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.name}</Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    ))
                                )}
                                <Typography variant="body2" sx={{ mt: 2, mb: 1, color: '#666', fontStyle: 'italic' }}>
                                    * Required: Enter mobile number, select coupon checkbox, and set future expiry date for each coupon you want to create.
                                </Typography>
                                <Tooltip title="Create Coupons for the selected coupons">
                                    <Button variant="contained" sx={{ mt: 1 }} onClick={() => handleCreateCoupons(mobile)}>
                                        Create Coupon
                                    </Button>
                                </Tooltip>
                            </Box>
                            <Snackbar
                                open={showCouponSuccess}
                                autoHideDuration={3000}
                                onClose={() => setShowCouponSuccess(false)}
                                message="Coupon added successfully"
                                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                            />
                        </TabPanel>

                    </TabContext>
                </LocalizationProvider>
            </Box>
    );
};

export default AdminHome;

